import { ButtonGroup, Dropdown, DropdownButton } from "react-bootstrap";
import { deleteTimeoutReport } from "../../../../redux/slices/reports";

const getBaseCols = ({
  t,
  backgroundColor,
  fontColor,
  notyf,
  dispatch,
  setTimeoutReportId,
  setTimeoutReportTableIsShown,
}) => ({
  id: { Header: "ID", accessor: "id" },
  name: { Header: "Name", accessor: "name" },
  type: { Header: "Type", accessor: "type" },
  status: { Header: "Status", accessor: "status" },
  createdAt: { Header: "Created At", accessor: "createdAt" },
  finalizedAt: { Header: "Finalized At", accessor: "finalizedAt" },
  actions: {
    Header: "Actions",
    accessor: "actions",
    Cell: ({ row }) => {
      const id = row.original.id;
      const isDone = row.original.status === "Done";
      const isFailed = row.original.status === "Failed";

      return (
        <DropdownButton
          as={ButtonGroup}
          title={t("Actions")}
          variant="secondary"
          size="sm"
          style={{
            "--dynamic-bg-color": backgroundColor ?? "#0E1A2B",
            "--dynamic-font-color": fontColor ?? "#ffffff",
            border: "none",
          }}
        >
          {isDone && (
            <Dropdown.Item
              eventKey="view"
              onClick={() => setTimeoutReportId(id)}
            >
              {t("timeoutReports.view")}
            </Dropdown.Item>
          )}
          {(isDone || isFailed) && (
            <Dropdown.Item
              eventKey="delete"
              onClick={async () => {
                setTimeoutReportTableIsShown(false);
                try {
                  await dispatch(deleteTimeoutReport({ id }));
                  notyf.open({
                    type: "success",
                    message: t("timeoutReports.deleted"),
                    duration: 5000,
                    ripple: true,
                    dismissible: false,
                    position: { x: "center", y: "top" },
                  });
                } catch (error) {
                  notyf.open({
                    type: "danger",
                    message: error,
                    duration: 5000,
                    ripple: true,
                    dismissible: false,
                    position: { x: "center", y: "top" },
                  });
                }
              }}
            >
              {t("timeoutReports.delete")}
            </Dropdown.Item>
          )}
        </DropdownButton>
      );
    },
  },
});

export default getBaseCols;
